/* eslint-disable @typescript-eslint/naming-convention */

import {
  createComponentClickedEvent,
  createScreenViewedEvent,
  track,
  type ComponentType,
} from "./base"
import type { AppScreen } from "@/constants/Screens"

export const homeViewed = (marketingWidgetTitle?: string | null) => {
  track(
    createScreenViewedEvent({
      current_screen: "Home",
      current_tab: "Home",
      marketing_widget_title: marketingWidgetTitle,
    })
  )
}

export const homepageWidgetClicked = ({
  nextScreen,
  widgetType,
  widgetState,
  widgetCta,
  widgetTitle,
  widgetValue,
}: {
  nextScreen: AppScreen
  widgetType: Extract<ComponentType, `widget-${string}`>
  widgetState?: "zero-value" | "non-zero-value"
  widgetCta?: string
  widgetTitle?: string
  widgetValue?: string
}) => {
  track(
    createComponentClickedEvent({
      current_screen: "Home",
      to_screen: nextScreen,
      component_type: widgetType,
      component_function: "home-widget",
      clicked_values: {
        widget_state: widgetState,
        widget_cta: widgetCta,
        widget_title: widgetTitle,
        widget_value: widgetValue,
      },
    })
  )
}

export const requestPreApproval = () => {
  track(
    createComponentClickedEvent({
      current_screen: "Subject Property Calculate",
      component_type: "text_link",
      component_function: "request pre-approval letter",
      component_text: "Get a Pre-approval letter",
    })
  )
}

export const requestPreApprovalConfirm = () => {
  track(
    createComponentClickedEvent({
      current_screen: "PreApproval Letter Modal",
      component_type: "button",
      component_function: "submit pre-approval request",
      component_text: "Confirm",
    })
  )
}

export const preApprovalView = (screen: AppScreen) => {
  track(
    createScreenViewedEvent({
      current_screen: "PreApproval Letter Modal",
      from_screen: screen,
    })
  )
}

export const marketingWidgetClicked = ({
  widgetType,
  widgetState,
  widgetCta,
  widgetTitle,
  widgetValue,
  widgetLink,
}: {
  widgetType: Extract<ComponentType, `widget-${string}`>
  widgetState?: "zero-value" | "non-zero-value"
  widgetCta?: string
  widgetTitle?: string
  widgetValue?: string
  widgetLink?: string
}) => {
  track(
    createComponentClickedEvent({
      current_screen: "Home",
      component_type: widgetType,
      component_function: "home-widget",
      clicked_values: {
        widget_state: widgetState,
        widget_cta: widgetCta,
        widget_title: widgetTitle,
        widget_value: widgetValue,
        widgetLink,
      },
    })
  )
}
